<template>
  <div class="eb-download-file" v-show="isUploaded">
    <i class="icon iconfont icon-fujianxiazai" @click="handleDownloadClick"></i>
    <span @click="handleDownloadClick">{{ fileName }}</span>
  </div>
</template>
<script>
import { baseURL } from '@/plugins/axios.js';
import { downloadFile } from '@/plugins/download-file';

export default {
  name: 'EbDownloadFile',
  components: {},
  filters: {},
  props: {
    fileUrl: {
      type: String
    }
  },
  data() {
    return {};
  },
  computed: {
    isUploaded() {
      return this.fileUrl && this.fileUrl !== '';
    },
    fileName() {
      return this.$options.filters['projFileName'](this.fileUrl);
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleDownloadClick() {
      downloadFile(baseURL + this.fileUrl, this.$options.filters['projFileName'](this.fileUrl));
    }
  }
};
</script>
<style lang="less">
.eb-download-file {
  cursor: pointer;
  .icon {
    font-size: 30px;
  }
}
</style>
